import { z } from 'zod';

/** Envoltorio común de las respuestas del backend: `{ success, statusCode, data }`. */
export function apiEnvelope<T extends z.ZodType>(data: T) {
  return z.object({ success: z.boolean(), statusCode: z.number(), data });
}

/** Número que el backend puede enviar como string (`"27068.0"`); expone siempre `number`. */
export const numericString = z.union([
  z.number(),
  z
    .string()
    .trim()
    .regex(/^-?\d+(\.\d+)?$/, 'Se esperaba un número')
    .transform(Number),
]);

/** Valor con que el backend representa una fecha ausente. */
export const NULL_BACKEND_DATE = '0000-00-00T00:00:00';

/** Fecha del backend; `0000-00-00T00:00:00`, vacío o `null` se exponen como `null`. */
export const backendDate = z
  .string()
  .nullable()
  .transform((value) => (!value || value.startsWith('0000-00-00') ? null : value));

/**
 * Lista de filas, o `{ Message }` sin filas, que se interpreta como lista vacía.
 * El backend responde `{ Message: "OK" }` cuando una consulta válida no devuelve datos.
 */
export function rowsOrMessage<T extends z.ZodType>(row: T) {
  return z.union([
    z.array(row),
    z.strictObject({ Message: z.string() }).transform((): z.output<T>[] => []),
  ]);
}

/** Texto del backend; vacío o solo espacios se expone como `null`, y el resto sin espacios sobrantes. */
export const optionalText = z.string().transform((value) => value.trim() || null);

/** Número de comprobante (remito); `"0"` o vacío significa que no hay. */
export const optionalDocument = optionalText.transform((value) => (value === '0' ? null : value));

/** Toneladas a kg, redondeado a kg enteros para evitar errores de coma flotante. */
export const tonsToKg = (t: number) => Math.round(t * 1000);
